import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';;
import { BaselayoutComponent } from './baselayout/baselayout.component';
import { FlagComponent } from './actuals/flag/flag.component';
import { TimeEntryComponent } from './actuals/time-entry/time-entry.component';
import { SustainabilityComponent } from './actuals/sustainability/sustainability.component';
import { ExpenseEntryComponent } from './actuals/expense-entry/expense-entry.component';
import { TimeDicerComponent } from './actuals/time-dicer/time-dicer.component';
import { MipsRouteGuard } from './common/utilities/mips.routeguard';
import { PagesRouteGuard } from './common/utilities/pages.routeguard';
import { ReportEmbedComponent } from './report-embed/report-embed.component';
import { ProjectDetailsComponent } from './project-details/project-details.component';
import { AddProjectPageComponent } from './add-project-page/add-project-page.component';
import { TimeEntryForPlanningComponent } from './planning/time-entry/time-entry-for-planning.component';
import { AddClientComponent } from './add-client/add-client.component';
import { FinanceExpenseComponent } from './finance-expense/finance-expense.component';
import { InvoiceDetailsComponent } from './invoice-details/invoice-details.component';
import { permissionGuard } from 'app/core/rbac/permission.guard';



const mipsRoutes: Routes = [
    {
        path: 'core',
        component: BaselayoutComponent,
        canActivate: [MipsRouteGuard,PagesRouteGuard],
        canDeactivate: [PagesRouteGuard],
        canActivateChild: [MipsRouteGuard],
        children: [
            {
                path: 'actuals',
                children: [
                    {
                        path: '',
                        redirectTo: 'time',
                        pathMatch: 'full'
                    },
                    {
                        path: 'flag',
                        component: FlagComponent
                    },
                    {
                        path: 'time',
                        component: TimeEntryComponent,
                        canDeactivate: [PagesRouteGuard]
                    },
                    {
                        path: 'expense',
                        component: ExpenseEntryComponent,
                        canDeactivate: [PagesRouteGuard]
                    },
                    {
                        path: 'sustainability',
                        component: SustainabilityComponent,
                        canDeactivate: [PagesRouteGuard]
                    },

                    {
                        path: 'time-dicer',
                        component: TimeDicerComponent,
                        canActivate:[PagesRouteGuard]
                    },
                    // {
                    //     path: 'dummy',
                    //     component: DummyComponent
                    // }
                ]
            },
            {
                path: 'report-embed/:reporturl',
                component: ReportEmbedComponent,
                canActivate: [PagesRouteGuard]

            },
           {
                path: 'finance-expense',
                component: FinanceExpenseComponent,
                // PagesRouteGuard: existing mobile-block check (runs first).
                // permissionGuard: allows only users whose RBAC permissions include 'finance'.
                canActivate: [PagesRouteGuard, permissionGuard],
                data: { permission: 'finance' }
            },
                        {
                path: 'project-details',
                children: [
                    // {
                    //     path: 'view',
                    //     component: ProjectDetailsComponent,
                    //     data: { mode: 'view' }
                    // },
                    {
                        path: 'add',
                        component: ProjectDetailsComponent,
                        canActivate: [PagesRouteGuard],
                        canDeactivate: [PagesRouteGuard],
                        data: { mode: 'add' }
                    },
                    {
                        path: 'edit',
                        component: ProjectDetailsComponent,
                        canActivate:[PagesRouteGuard],
                        canDeactivate: [PagesRouteGuard],
                        data: { mode: 'edit' }
                    }
                ]

            },
            {
                path: 'client',
                children: [
                    {
                        path: 'add-client',
                        component: AddClientComponent,
                        canActivate: [PagesRouteGuard]
                    }
                ]
            },
                      {
                path: 'planning',
                children: [
                    {
                        path: 'time-entry',
                        component: TimeEntryForPlanningComponent,
                    }
                ]
            },
            {
                path: 'invoice-details',
                children: [
                    {
                        path: '',
                        component: InvoiceDetailsComponent
                    }
                ]
            }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(mipsRoutes)],
    exports: [RouterModule]
})
export class MipsRoutingModule { }
